import React from'react';
const Footer=(props)=>{
    return(<React.Fragment> 
		<div className="page-content page-content-custom" style={{ paddingLeft: "50%" }}><p className="copyright-string-footer" style={{align:"right"}}>
                  &copy; 2022 Developed by Eurolink S.r.l.
                </p></div></React.Fragment>)
}
export default Footer;